import dateFormat from 'dateformat';
import parse from 'date-fns/parse';

export function humanReadableDate (timestamp) {
  const nowTimestamp = (new Date()).getTime();
  const diff = (nowTimestamp - timestamp) / 1000;

  const MESSAGES = {
    now: () => '방금',
    minutes: diff => `${Math.floor(diff / 60)}분전`,
    hours: diff => `${Math.floor(diff / 3600)}시간전`,
    date: timestamp => dateFormat(new Date(timestamp), 'yyyy.mm.dd'),
  };

  return diff < 60 && MESSAGES.now() ||
    diff < 3600 && MESSAGES.minutes(diff) ||
    diff < 34560 && MESSAGES.hours(diff) ||
    MESSAGES.date(timestamp);
}

export function formatDateTimeString (s) {
  const date = Date.parse(s);

  return dateFormat(date, 'yyyy. m. d. HH:MM');
}

export function parseDateTimeString (s) {
  return parse(s, 'yyyy-MM-dd HH:mm:ss', new Date());
}
